import React from "react";
import { FaHeart } from "react-icons/fa";

const LoadingOverlay = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center"
      style={{
        backgroundColor: "rgba(15, 23, 42, 0.45)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
      }}
    >
      <style>{`
        @keyframes heartbeat {
          0%   { transform: scale(1);    }
          15%  { transform: scale(1.4);  }
          30%  { transform: scale(1);    }
          45%  { transform: scale(1.25); }
          60%  { transform: scale(1);    }
          100% { transform: scale(1);    }
        }
        @keyframes ring-expand {
          0%   { transform: scale(0.8); opacity: 0.7; }
          100% { transform: scale(2.2); opacity: 0;   }
        }
        @keyframes ecg-draw {
          0%   { stroke-dashoffset: 300; opacity: 1;   }
          75%  { stroke-dashoffset: 0;   opacity: 1;   }
          90%  { stroke-dashoffset: 0;   opacity: 0.3; }
          100% { stroke-dashoffset: 300; opacity: 0;   }
        }

        .hb     { animation: heartbeat  1.4s ease-in-out infinite; }
        .ring-a { animation: ring-expand 1.8s ease-out  infinite 0s;    }
        .ring-b { animation: ring-expand 1.8s ease-out  infinite 0.5s;  }
        .ring-c { animation: ring-expand 1.8s ease-out  infinite 1.0s;  }
        .ecg    {
          stroke-dasharray: 300;
          animation: ecg-draw 2.2s ease-in-out infinite;
        }
      `}</style>

      <div className="flex flex-col items-center gap-6">

        {/* Heart with rings */}
        <div className="relative flex items-center justify-center"
          style={{ width: "100px", height: "100px" }}
        >
          {/* Triple pulse rings */}
          <div className="ring-a absolute inset-0 rounded-full"
            style={{ border: "2px solid rgba(230, 57, 70, 0.6)" }} />
          <div className="ring-b absolute inset-0 rounded-full"
            style={{ border: "2px solid rgba(230, 57, 70, 0.4)" }} />
          <div className="ring-c absolute inset-0 rounded-full"
            style={{ border: "2px solid rgba(230, 57, 70, 0.2)" }} />

          {/* Heart icon */}
          <div className="hb relative z-10">
            <FaHeart
              style={{
                fontSize: "56px",
                color: "#e63946",
                filter: "drop-shadow(0 0 16px rgba(230,57,70,0.7)) drop-shadow(0 0 32px rgba(230,57,70,0.3))",
              }}
            />
          </div>
        </div>

        {/* ECG line below heart */}
        <svg
          viewBox="0 0 220 32"
          style={{ width: "180px", height: "28px" }}
          fill="none"
        >
          {/* Faint track */}
          <path
            d="M0,16 L35,16 L45,16 L52,3 L59,29 L66,16 L80,16 L86,8 L93,24 L100,16 L115,16 L121,4 L128,28 L135,16 L150,16 L156,10 L163,22 L170,16 L220,16"
            stroke="rgba(230,57,70,0.2)"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          {/* Animated line */}
          <path
            d="M0,16 L35,16 L45,16 L52,3 L59,29 L66,16 L80,16 L86,8 L93,24 L100,16 L115,16 L121,4 L128,28 L135,16 L150,16 L156,10 L163,22 L170,16 L220,16"
            stroke="#e63946"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="ecg"
          />
        </svg>

      </div>
    </div>
  );
};

export default LoadingOverlay;